function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M14.1,28.4c7.9,0,14.2-6.3,14.2-14.2S22,0,14.1,0S0,6.4,0,14.2S6.3,28.4,14.1,28.4z M7.9,12.9l8.9-6.8 c0.3-0.2,0.6-0.3,1-0.3c0.5,0,1,0.2,1.3,0.6c0.5,0.8,0.4,1.8-0.3,2.4l-7.1,5.5l7.2,5.4c0.6,0.5,0.9,1.6,0.2,2.4 c-0.5,0.8-1.6,0.9-2.4,0.3l-8.9-6.8c-0.4-0.3-0.6-0.9-0.6-1.3C7.1,13.7,7.5,13.2,7.9,12.9z"
});

var SvgButtonBack = function SvgButtonBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.4 28.4",
    style: {
      enableBackground: "new 0 0 28.4 28.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_back.eb0349e7.svg";
export { ForwardRef as ReactComponent };